import React, { useEffect } from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLangField } from '../../../../../../hooks/useLangField';

export const ModalService = ({ mode, open, onCancel, onSubmit, initialValues }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const getLangField = useLangField();
  const organizationTypes = useSelector((state) => state.dictionaries.organizationTypes);

  useEffect(() => {
    if (open) {
      form.setFieldsValue(
        initialValues !== null && initialValues !== undefined
          ? {
              ...initialValues,
              orgTypeId: initialValues.orgType.id,
            }
          : { orgTypeId: undefined, code: '', name: '' }
      );
    }
  }, [open, initialValues, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    if (initialValues && initialValues.id) values.id = initialValues.id;
    try {
      await onSubmit({ mode, values });
      form.resetFields();
      onCancel();
    } catch {
      // оставляем модалку открытой — пользователь видит тост и правит поле
    }
  };

  return (
    <Modal
      title={
        mode === 'create'
          ? t('governmentServiceEducation.modalTitleAddNewService')
          : t('governmentServiceEducation.modalTitleEditService')
      }
      open={open}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      okText={
        mode === 'create'
          ? t('governmentServiceEducation.create')
          : t('governmentServiceEducation.save')
      }
      cancelText={t('governmentServiceEducation.cancel')}
      destroyOnClose
      width={560}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t('governmentServiceEducation.organizationType')}
          name="orgTypeId"
          rules={[{ required: true, message: t('error.requiredField') }]}
        >
          <Select
            placeholder={t('governmentServiceEducation.chooseOrganizationType')}
            options={organizationTypes.map((type) => ({
              value: type.id,
              label: getLangField(type, 'name'),
            }))}
          />
        </Form.Item>

        <Form.Item
          label={t('governmentServiceEducation.serviceCode')}
          name="code"
          rules={[
            { required: true, message: t('error.requiredField') },
            { max: 6, message: t('error.maxSymbols', { n: 6 }) },
            { pattern: /^[0-9]+$/, message: t('error.onlyNumbers') },
          ]}
        >
          <Input placeholder={t('governmentServiceEducation.fillServiceCode')} />
        </Form.Item>

        <Form.Item
          label={t('governmentServiceEducation.nameService')}
          name="name"
          rules={[
            { required: true, message: t('error.requiredField') },
            { max: 60, message: t('error.maxSymbols', { n: 60 }) },
          ]}
        >
          <Input placeholder={t('governmentServiceEducation.fillNameService')} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
